import React, { ReactElement } from 'react';

import { CSSProps } from '../../utils/misc';

type SVGProps = React.SVGProps<SVGSVGElement>;

type Props = {
  icon: React.FC<SVGProps>;
  x?: number;
  d?: number;
  // color?: string;
  colorPropety?: string;
};

type ImageSize = { width: number; height: number };

const SvgIcon = ({
  className,
  icon: IconComponent,
  x = 1,
  d,
}: Props & CSSProps) => {
  const Component = IconComponent({}) as ReactElement<SVGProps & ImageSize>;
  const { width, height } = Component.props ?? { width: 24, height: 24 };

  const ratio = d ? d / width : x;

  return (
    <i>
      <IconComponent
        className={className}
        width={Math.round(width * ratio)}
        height={Math.round(height * ratio)}
        viewBox={`0 0 ${width} ${height}`}
      />
    </i>
  );
};

export default SvgIcon;
